var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMdiContactOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.875 11.875H3.125V3.125H11.875M11.875 1.875H3.125C2.79348 1.875 2.47554 2.0067 2.24112 2.24112C2.0067 2.47554 1.875 2.79348 1.875 3.125V11.875C1.875 12.2065 2.0067 12.5245 2.24112 12.7589C2.47554 12.9933 2.79348 13.125 3.125 13.125H11.875C12.2065 13.125 12.5245 12.9933 12.7589 12.7589C12.9933 12.5245 13.125 12.2065 13.125 11.875V3.125C13.125 2.79348 12.9933 2.47554 12.7589 2.24112C12.5245 2.0067 12.2065 1.875 11.875 1.875ZM10.3125 10.1562C10.3125 9.21875 8.4375 8.75 7.5 8.75C6.5625 8.75 4.6875 9.21875 4.6875 10.1562V10.625H10.3125M7.5 7.65625C7.87296 7.65625 8.23065 7.50809 8.49437 7.24437C8.75809 6.98065 8.90625 6.62296 8.90625 6.25C8.90625 5.87704 8.75809 5.51935 8.49437 5.25563C8.23065 4.99191 7.87296 4.84375 7.5 4.84375C7.12704 4.84375 6.76935 4.99191 6.50563 5.25563C6.24191 5.51935 6.09375 5.87704 6.09375 6.25C6.09375 6.62296 6.24191 6.98065 6.50563 7.24437C6.76935 7.50809 7.12704 7.65625 7.5 7.65625Z",
    fill: "#970A02"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdiContactOutline);
export default __webpack_public_path__ + "static/media/mdi_contact-outline.97b548fbb575b9ee40aa25623bf97aa0.svg";
export { ForwardRef as ReactComponent };